// @module NXTurn.ShoppingExtensions.PDP
define('C3.ShoppingExtensions.CartPage.Wishlist.Rightside.ListControl.Item.View'
,   [
        'c3_shoppingextensions_cartpage_wishlist_rightside_listcontrol_item.tpl'
       ,   'AjaxRequestsKiller'
        ,   'Utils'
    ]
, function (
        c3_shoppingextensions_cartpage_wishlist_rightside_listcontrol_item_tpl
        ,   AjaxRequestsKiller
        ,   Utils
)
{
    'use strict';

    // @class NXTurn.ShoppingExtensions.PDP.View @extends Backbone.View
    return Backbone.View.extend({

    tagName: 'li',

    template: c3_shoppingextensions_cartpage_wishlist_rightside_listcontrol_item_tpl,

    events: {
       // 'click [data-action="product-list-item"]': 'pListItemHandler',
        'click [data-action="remove-from-product-list"]': 'removeFromWishList',
        'click [data-action="add-to-product-list"]': 'AddToWishList'
    },

    initialize: function(options) {
        this.model = options.model; //  ProductList.Model
        this.line = options.product; // Product.Model
        this.application = options.application;
        this.parentView = options.parentView;

        this.collection = options.collection;
    },

    // @method checked Determines if an item is checked if the item belongs the list
    // Whilst on move mode, returns always false @return {Boolean}
    /*checked: function() {
        return this.parentView.mode !== 'move' ? this.model.checked(this.line) : false;
    },*/

    // @method pListItemHandler dispatch mouse event - if move mode enabled, move the item, if not, an item is added/removed from a list
    /*pListItemHandler: function(e) {
        e.preventDefault();
        const self = this;
        const checkbox = jQuery(e.target);

        if (self.parentView.mode === 'move') {
            self.moveProduct();
        } else {
            self.addRemoveProduct(checkbox);
        }
    },*/

    // @method moveProduct Moves an item to another list
    /*moveProduct: function() {
        this.parentView.moveProductHandler(this.model).then(() => {
            this.application.ProductListModule.Utils.updateProductListMenu();
        });
    },*/

    // @method addRemoveProduct Adds/removes an item from a list @param {jQuery} checkbox
    /*addRemoveProduct: function($checkbox) {
        $checkbox.attr('disabled', true);
        if ($checkbox.is(':checked')) {
            // add to list
            this.parentView.addItemToList(this.line, this.model).then(() => {
                this.application.ProductListModule.Utils.updateProductListMenu();
            });
        } else {
            // remove from list
            this.removeItemFromList(this.line);
            this.application.ProductListModule.Utils.updateProductListMenu();
        }
    },*/


    AddToWishList: function(e){
        this.parentView.addItemToList(this.line, this.model).then(() => {
                this.application.ProductListModule.Utils.updateProductListMenu();
            });
    },

    removeFromWishList: function(e){
        this.removeItemFromList(this.line);
            this.application.ProductListModule.Utils.updateProductListMenu();
    },

    // @method removeItemFromList Remove a line list item from the product list
    // @param {Item.Model} product
    removeItemFromList: function(line) {
        const self = this;
        const selected_line = self.model.get('items').find(function(product_list_line) {
            var itm = product_list_line.get('item')

            return itm.get('internalid') == line.get('internalid')
        });

        //console.log(selected_line)

        if (selected_line) {
            selected_line.set('productList', {
                id: self.model.get('internalid'),
                owner: self.model.get('owner').id
            });
            self.model.get('items').remove(selected_line);

            selected_line.destroy().done(function() {
                self.model.collection.trigger('changed');
                self.parentView.render();
                self.parentView.hideConfirmationMessage();

                $('.wishlist-title h1').html('Item removed');

                var plCollection = self.collection
                ,   plCollectionModels = plCollection.models
                ,   mainPLCollectionArray = []

                mainPLCollectionArray = _.flatten(_.map(plCollectionModels, function(mod) {
                    var its = mod.get('items')
                    ,   its_model = its.models
                    return its_model
                }));
            
                var foundIt = mainPLCollectionArray.find(function(pl_line) {
                    var im = pl_line.get('item')

                    return im.get('internalid') == line.get('internalid')
                });

                if(!foundIt){
                    var appendingChild = "<img class='heart' data-element='add-to-favourites' src='/sca-b2c-2023/img/Heart.svg'>";
                    var parElement = $('.cartitem-'+line.get('internalid')+'')
                    parElement.children().remove();
                    parElement.append(appendingChild)
                }

            });
        } else {
            self.parentView.render();
        }
    },

    // @method getContext @return {ProductList.ControlItem.View.Context}
    getContext: function() {

        var currentItem = this.line.get('internalid')
        ,   alreadyInWishlist = false;

        //console.log(this.model.get('url'))

        var list_items = this.model.get('items')
        if(list_items){
           _.each(list_items.models,function(line){
            var line_item = line.get('item')
            ,   line_item_id = line_item.get('internalid');

            if(line_item_id == currentItem)
                alreadyInWishlist = true;
           });
        }

        return {
            // @class ProductList.ControlItem.View.Context
            // @property {Boolean} isMoving
            isMoving: this.parentView.mode === 'move',
            // @property {Boolean} isChecked
            isChecked: alreadyInWishlist/*this.checked()*/,
            // @property {Boolean} isTypePredefined
            isTypePredefined: this.model.get('typeName') === 'predefined',
            // @property {String} itemName
            itemName: this.model.get('typeName') === "predefined" ? 'Saved for Later' : this.model.get('name'),
            // @property {String} listId
            listId: this.model.get('internalid'),
            wishListLink : this.model.get('url')
        };
      }
    });
});
